import React from 'react'
import { DestinationForm } from './DestinationForm'
import { CargoMainInfoForm } from './CargoMainInfoForm'
import { CargoOptionalFeaturesForm } from './CargoOptionalFeaturesForm'

export function DeliveryPointForm ({ name, disabled }) {
  return (
    <>
      <DestinationForm name={name} disabled={disabled}/>
      <CargoMainInfoForm name={name} disabled={disabled}/>
      <CargoOptionalFeaturesForm name={`${name}.optionalFeatures`} disabled={disabled}/>
    </>
  )
}
